import { message } from 'antd';

message.config({ maxCount: 1, duration: 1 });
